export default __webpack_public_path__ + "static/media/hero.547e5603.png";